import { render, staticRenderFns } from "./SelectAmount.vue?vue&type=template&id=434613c6"
import script from "./SelectAmount.vue?vue&type=script&lang=ts"
export * from "./SelectAmount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports